import { useMemo as m } from "react";
import { A } from "../../../index.modern-BBWGIH4W.js";
import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as a } from "../../../context/theme/hooks.js";
import { BACKGROUND_OVERLAY_OPACITY as l } from "../consts.js";
import { baseColorHexToRGBA as s, overlayColorHexToRGBA as u, RGBAToString as c, RGBAToHex as B } from "../utils.js";
function g(r = "RGBA") {
  const o = a();
  return m(() => {
    const t = s(o["background-base"]), n = u(
      o["background-overlay"],
      l
    ), e = A(t, n);
    return r === "RGBA" ? c(e) : B(e);
  }, [r, o]);
}
export {
  g as default
};
